// extracted by mini-css-extract-plugin
export default {"menuWrap":"MobileMypage_menuWrap__b922n"};